import Reveal from "./Reveal";

const SEARCH_TERMS = [
    "elder law attorney",
    "Medicaid planning attorney",
    "estate planning lawyer",
    "trust attorney",
    "elder law lawyer near me",
];

export const Strategy = () => (
    <section
        id="strategy"
        className="py-24 md:py-32 lg:py-40 bg-ink-800/40 border-y border-white/5"
    >
        <div className="shell">
            <Reveal className="max-w-3xl">
                <p className="eyebrow mb-5">Google + Meta Strategy</p>
                <h2 className="font-serif font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-white">
                    Capture demand. Create demand.
                </h2>
            </Reveal>
            <Reveal delay={0.15} className="mt-14 md:mt-16">
                <div className="relative overflow-hidden border border-white/10 h-44 md:h-60">
                    <img
                        src="https://images.unsplash.com/photo-1698847626251-efac0f7517cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwZ2VvbWV0cmljJTIwZGFya3xlbnwwfHx8fDE3OTEyMDc5NjB8MA&ixlib=rb-4.1.0&q=80&auto=format&fit=crop&w=1600"
                        alt="Overlapping dark geometric planes"
                        className="h-full w-full object-cover grayscale brightness-[0.5]"
                        loading="lazy"
                    />
                    <div
                        aria-hidden="true"
                        className="absolute inset-0 bg-gradient-to-r from-ink-900 via-transparent to-ink-900"
                    />
                </div>
            </Reveal>
            <div className="mt-14 grid lg:grid-cols-2 gap-6">
                <Reveal delay={0.1} className="h-full">
                    <div
                        data-testid="strategy-google"
                        className="h-full border border-brass-500/40 bg-ink-900 p-8 md:p-12"
                    >
                        <p className="eyebrow">Google Ads</p>
                        <h3 className="mt-5 font-serif text-2xl md:text-3xl text-white">
                            Capture existing intent.
                        </h3>
                        <p className="mt-5 text-sm md:text-base text-zinc-400">
                            When someone is actively searching for:
                        </p>
                        <ul className="mt-4">
                            {SEARCH_TERMS.map((t) => (
                                <li
                                    key={t}
                                    className="font-serif italic text-lg md:text-xl text-zinc-200 border-b border-white/5 py-3"
                                >
                                    "{t}"
                                </li>
                            ))}
                        </ul>
                        <p className="mt-7 text-sm md:text-base text-zinc-400 leading-relaxed">
                            Google puts the firm in front of people who are
                            already looking for help.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.2} className="h-full">
                    <div
                        data-testid="strategy-meta"
                        className="h-full border border-white/10 bg-ink-900 p-8 md:p-12"
                    >
                        <p className="text-xs uppercase font-semibold tracking-[0.22em] text-zinc-400">
                            Meta Ads
                        </p>
                        <h3 className="mt-5 font-serif text-2xl md:text-3xl text-white">
                            Build awareness and retarget.
                        </h3>
                        <p className="mt-5 text-sm md:text-base text-zinc-400 leading-relaxed">
                            Facebook and Instagram can introduce prospective
                            clients to the firm, educate them, and bring
                            previous website visitors back into the
                            conversation.
                        </p>
                    </div>
                </Reveal>
            </div>
            <Reveal delay={0.15}>
                <p className="mt-14 md:mt-20 max-w-3xl mx-auto text-center font-serif italic text-xl md:text-2xl text-zinc-300 leading-relaxed">
                    The strongest acquisition strategy isn't about choosing one
                    platform blindly. It's about using each channel for the job
                    it does best.
                </p>
            </Reveal>
        </div>
    </section>
);

export default Strategy;
